import React from 'react';
import { SnackbarProvider } from 'notistack';

/**
 * Root notistack wrapper. App must use this instead of importing notistack directly.
 */
export function AppSnackbarProvider({ children, ...rest }) {
  return <SnackbarProvider {...rest}>{children}</SnackbarProvider>;
}
